import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white py-12 relative overflow-hidden" data-id="element-32">
      {/* Animated background effect */}
      <div className="absolute inset-0 opacity-10" data-id="element-33">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-purple-500 to-pink-500 animate-pulse" data-id="element-34"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-36">
          <div data-id="element-37">
            <Link to="/" data-id="element-38">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/weJPa2B6KxMjVxBcMFKGGT/LOGO_GRUPO_REFLEX.png" alt="Grupo Reflex Logo" className="h-12 mb-4 brightness-0 invert" data-id="element-39" />
            </Link>
            <p className="text-gray-300 mt-4" data-id="element-40">
              Transformamos ideas en proyectos funcionales con pasión,
              creatividad e innovación impulsada por IA.
            </p>
          </div>
          <div data-id="element-41">
            <h3 className="text-lg font-semibold mb-4 text-purple-300" data-id="element-42">
              Enlaces rápidos
            </h3>
            <ul className="space-y-2" data-id="element-43">
              <li data-id="element-44">
                <Link to="/" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-45">
                  Inicio
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/servicios" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-47">
                  Servicios
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/historia" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-49">
                  Historia
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/proyectos" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-51">
                  Proyectos
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/testimonios" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-53">
                  Testimonios
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/contacto" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-55">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-56">
            <h3 className="text-lg font-semibold mb-4 text-purple-300" data-id="element-57">
              Contacto
            </h3>
            <div className="space-y-3" data-id="element-58">
              <div className="flex items-center" data-id="element-59">
                <PhoneIcon className="h-5 w-5 mr-2 text-purple-400" data-id="element-60" />
                <span className="text-gray-300" data-id="element-61">+502 4693-3600</span>
              </div>
              <div className="flex items-center" data-id="element-62">
                <MailIcon className="h-5 w-5 mr-2 text-purple-400" data-id="element-63" />
                <a href="mailto:reflexmediagt@gmail.com" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-64">
                  reflexmediagt@gmail.com
                </a>
              </div>
              <div className="flex space-x-4 mt-4" data-id="element-65">
                <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-66">
                  <FacebookIcon className="h-5 w-5" data-id="element-67" />
                </a>
                <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-68">
                  <InstagramIcon className="h-5 w-5" data-id="element-69" />
                </a>
                <a href="#" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-70">
                  <LinkedinIcon className="h-5 w-5" data-id="element-71" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-purple-800 mt-8 pt-8 text-center text-gray-400 text-sm" data-id="element-72">
          <p data-id="element-73">
            &copy; {new Date().getFullYear()} Grupo Reflex S.A. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;